var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCircleClose = function SvgCircleClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875 8.5C0.875 12.9858 4.5142 16.625 9 16.625C13.4858 16.625 17.125 12.9858 17.125 8.5C17.125 4.0142 13.4858 0.375 9 0.375C4.5142 0.375 0.875 4.0142 0.875 8.5ZM15.875 8.5C15.875 12.2954 12.7954 15.375 9 15.375C5.20455 15.375 2.125 12.2954 2.125 8.5C2.125 4.70455 5.20455 1.625 9 1.625C12.7954 1.625 15.875 4.70455 15.875 8.5ZM6.05806 11.4419C6.29875 11.6826 6.6869 11.686 6.93168 11.452L6.94194 11.4419L9 9.38388L11.0581 11.4419C11.3021 11.686 11.6979 11.686 11.9419 11.4419C12.1826 11.2013 12.186 10.8131 11.952 10.5683L11.9419 10.5581L9.88388 8.5L11.9419 6.44194C12.186 6.19786 12.186 5.80214 11.9419 5.55806C11.7013 5.31737 11.3131 5.31403 11.0683 5.54803L11.0581 5.55806L9 7.61612L6.94194 5.55806C6.69786 5.31398 6.30214 5.31398 6.05806 5.55806C5.81737 5.79875 5.81403 6.1869 6.04803 6.43168L6.05806 6.44194L8.11612 8.5L6.05806 10.5581C5.81398 10.8021 5.81398 11.1979 6.05806 11.4419Z",
    fill: "#808080"
  })));
};

export { SvgCircleClose as ReactComponent };
export default __webpack_public_path__ + "static/media/images/circleClose.svg";